<template>
    <div class="py-3 px-3 bg-white shadow-sm text-dark d-flex justify-content-between">

        <div class="d-flex align-items-center">

            <div v-if="$route.name !== 'workspace'" class="headline mx-3">
                <router-link :to="{ name: 'apps' }" class="no-underline">
                    we<span class="text-success">base</span>
                </router-link>

            </div>

            <div v-else class="headline text-uppercase mx-3 text-primary">
                webase
            </div>

            <div v-if="app && app.id && model.currentCollaboratorId" class="d-flex align-items-center mx-3">

                <div style="width: 34px; height: 34px;" class="rounded" :style="{ backgroundColor: blockColor }">
                    <div class="d-flex flex-column align-items-center mx-auto h-100">
                        <i :class="iconClass" class="m-auto fa-lg" :style="{ color: themeColor }"></i>
                    </div>
                </div>

                <div class="mx-2">
                    {{app.name}}
                </div>

                <div v-if="isEditAuthorized" class="btn-group">
                    <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="appSettingsDropdown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-ellipsis-h"></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="javascript:void(0)" @click="onEditClick">Edit details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="onOpenPublicApp">Open Public App</a>
                        <a v-if="isAdmin" class="dropdown-item" href="javascript:void(0)" @click="onOpenMobileApp">Open Mobile App</a>
                        <!--  <a v-if="model.app.website_id" class="dropdown-item" href="javascript:void(0)" @click="onEditSiteClick">Open Website Editor</a>-->
                    </div>
                </div>

            </div>
<!--            <div v-else>-->
<!--                No app id or collaborator id - {{model.app.id}} -&#45;&#45; {{model.currentCollaboratorId}}-->
<!--            </div>-->
        </div>

        <div class="d-flex align-items-center">

            <div v-if="model.currentUser && model.currentUser.image" style="width: 34px; height: 34px;"
                 class="d-flex align-items-center rounded-circle bg-dark text-white">
                <img :src="model.currentUser.image" class="rounded-circle" style="width: 34px; height: 34px;">
            </div>

            <div v-else-if="model.currentUser && model.currentUser.name" style="width: 34px; height: 34px;"
                 class="d-flex align-items-center rounded-circle bg-dark text-white">
                <div class="w-100 text-center text-uppercase">{{model.currentUser.name.substring(0,1)}}</div>
            </div>

            <div v-if="model.currentUser && model.currentUser.name" class="mx-2 dropdown">

                <a class="dropdown-toggle no-underline text-dark" href="javascript:void(0)" role="button" id="dropdownMenuLink"
                   data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Welcome {{model.currentUser.name}}
                </a>

                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" href="javascript:void(0)" @click="model.showAccountModal = true">view account</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="model.showSubscriptionModal = true">subscription</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="onLogoutClick">logout</a>
                    <a class="dropdown-item" href="/">webase.com</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import UserService from "../services/UserService";

    export default {
        name: 'DesktopNav',
        // props: ['app'],
        data() {
            return {
                model: webase.model,
                collapsed: false,
                app: null
            }
        },
        mounted() {
            webase.eventDispatcher.on('onAppLoaded', this.onAppLoaded)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('onAppLoaded', this.onAppLoaded)
        },
        computed: {
            isAdmin() {
                return this.model.currentUser && webase.utils.user.isAdmin()
            },
            blockColor() {
                if (this.app && this.app.theme_color) {
                    return this.app.theme_color + '40'
                }

                return this.defaultThemeColor + '40'
            },
            themeColor() {
                if (this.app && this.app.theme_color) {
                    return this.app.theme_color
                }

                return this.defaultThemeColor
            },
            iconClass() {
                if (this.app && this.app.icon_class) {
                    return this.model.availableIcons[this.app.icon_class]
                }

                let randomIcon = webase.utils.array.random(webase.model.iconOptions)
                return this.model.availableIcons[randomIcon]
            },
            isEditAuthorized() {
                console.log('isEditAuthorized')
                let collaborator = webase.managers.app.currentCollaborator()
                console.log(collaborator)
                return webase.utils.auth.isEditAuthorized(this.app.user_app_uuid, collaborator)
            }
        },
        methods: {
            onAppLoaded(app) {
                this.app = app
            },
            onEditClick() {
                this.$router.push({name: 'edit-app', params: {id: this.app.id}})
            },
            onOpenPublicApp() {
                // let publicAppUrl = webase.utils.app.getBaseUrl() + '/app/' + this.model.app.id + '/view/' + this.model.app.default_view_id
                let publicAppUrl = webase.utils.app.getBaseUrl() + '/app/' + this.app.id
                window.open(publicAppUrl)
            },
            onOpenMobileApp() {
                let publicAppUrl = webase.utils.app.getBaseUrl() + '/mobile-app/' + this.app.id + '/signup'
                window.open(publicAppUrl)
            },
            onLogoutClick() {
                let service = new UserService()

                service.logout().then((response) => {
                    console.log('Logout successful')
                    window.localStorage.removeItem('WEBASE_SYSTEM_ID')
                    WEBASE_SYSTEM_ID = null
                    this.model.auth_token = null
                    this.$router.push({name: 'sign-in'})
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>